import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {GamesOpenSessionRecordHeaderComponent} from "./header/games-open-session-record-header.component";
import {IGameOpenSessionViewModel} from "../../../services/games-open-sessions/games-open-session.service.interface";
import {GamesOpenSessionRecordContentComponent} from "./content/games-open-session-record-content.component";
import {GamesOpenSessionRecordBox} from "./boxes/games-open-session-record.box";
import {CyClass} from "../../../../common/cy-classes";
import {useServices} from "../../../react-hooks/use-services.hook";

export const GamesOpenSessionRecordComponent: React.FC<{openSession: IGameOpenSessionViewModel}> = observer((props) => {
    const services = useServices();
    const [gameInfo, setGameInfo] = useState(services.games.gamesMap[props.openSession.gameType]);

    useEffect(() => {
        if(!gameInfo) {
            //this is for the case when the game is not anymore in the layout
            services.games.getGamesInfoForHistory([props.openSession.gameType]).then(gamesMap => {
                setGameInfo(gamesMap[props.openSession.gameType]);
            });
        }
    }, [gameInfo, props.openSession.gameType, services.games]);

    if(!gameInfo) {
        return null;
    }

    return (
        <GamesOpenSessionRecordBox className={CyClass('cy-open-session-record')}>
            <GamesOpenSessionRecordHeaderComponent openSession={props.openSession} gameInfo={gameInfo}/>
            <GamesOpenSessionRecordContentComponent openSession={props.openSession} gameInfo={gameInfo}/>
        </GamesOpenSessionRecordBox>
    )
})